/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BackgroundJobExecutionState = {
    NotRunning: 'NotRunning',
    Running: 'Running',
    Failed: 'Failed',
    Completed: 'Completed'
} as const;
export type BackgroundJobExecutionState = typeof BackgroundJobExecutionState[keyof typeof BackgroundJobExecutionState];


export function BackgroundJobExecutionStateFromJSON(json: any): BackgroundJobExecutionState {
    return BackgroundJobExecutionStateFromJSONTyped(json, false);
}

export function BackgroundJobExecutionStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackgroundJobExecutionState {
    return json as BackgroundJobExecutionState;
}

export function BackgroundJobExecutionStateToJSON(value?: BackgroundJobExecutionState | null): any {
    return value as any;
}

/**
 * Check if a given object implements the BackgroundJobExecutionState interface.
 */
 export function instanceOfBackgroundJobExecutionState(value: any): value is BackgroundJobExecutionState {
    return Object.values(BackgroundJobExecutionState).includes(value)
}

